import { Outlet } from '@tanstack/react-router';

import { FeatureNotEnabledView } from 'common/components/cookbook/FeatureNotEnabledView/FeatureNotEnabledView';
import { useFeatureEnabled } from 'common/feature-flag/hooks/useFeatureEnabled';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSelectedWarehouse } from 'common/hooks/useSelectedWarehouse';

const VenueSettingsEnabledRoute = () => {
  const f = useFormatMessage();

  const warehouseId = useSelectedWarehouse().id;

  const isV1Venue = useFeatureEnabled(
    'warehouse-v1-functionality',
    warehouseId ? [warehouseId] : undefined,
  );

  const viewTitle = f('venue_settings.venue_settings');

  if (!isV1Venue) {
    return <Outlet />;
  }

  return (
    <FeatureNotEnabledView
      viewTitle={viewTitle}
      description={f('warehouse.common.no_permission')}
    />
  );
};

export default VenueSettingsEnabledRoute;
